import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { productsData } from "../../data/productsData";

const SITE_URL = "https://www.callsoftbd.com";

const PRODUCT_KEYWORDS = {
  "software-solutions": "CRM software , ERP system Bangladesh and whole world, business management software , HR payroll software Bangladesh and whole world, enterprise software ",
  "infrastructure-servers": "server infrastructure , rack server Bangladesh and whole world, networking hardware , storage solutions Bangladesh and whole world, IT hardware ",
  "cloud-saas-product": "SaaS products , cloud software Bangladesh and whole world, subscription software , cloud tools Bangladesh and whole world, business SaaS ",
};

const allProducts = [
  { slug: "software-solutions", title: "Software Solutions", icon: "fa fa-desktop" },
  { slug: "infrastructure-servers", title: "Infrastructure & Servers", icon: "fa fa-server" },
  { slug: "cloud-saas-product", title: "Cloud SaaS Product", icon: "fa fa-cloud" }
];

export default function ProductPage({ slug }) {
  const product = productsData[slug];

  if (!product) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 20px' }}>
        <h1>Product Not Found</h1>
        <p>The requested product does not exist.</p>
        <Link to="/">Back to Home</Link>
      </div>
    );
  }

  const canonical = `${SITE_URL}/products/${slug}`;
  const desc = product.overview.desc.substring(0, 160);
  const ogTitle = `${product.title} — Callsoftbd `;

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Re-trigger AOS animations on route mount
      if (typeof AOS !== "undefined") {
        AOS.init({ easing: "ease-in-out-sine" });
      }
    }
  }, [slug]);

  return (
    <>
      <Helmet>
        <title>{product.title} — Callsoftbd </title>
        <meta name="description" content={desc} />
        <meta name="keywords" content={PRODUCT_KEYWORDS[slug] || `${product.title} , IT products Bangladesh`} />
        <link rel="canonical" href={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AE" />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="Callsoftbd" />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={`${SITE_URL}/assets/img/unsplash-1518770660439-4636190af475.jpg`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={`${SITE_URL}/assets/img/unsplash-1518770660439-4636190af475.jpg`} />
        <meta name="twitter:creator" content="@CallsoftbdBangladesh" />
      </Helmet>

      {/* ============ PAGE HERO ============ */}
      <section
        className="page-hero"
        style={{ backgroundImage: `url('${product.heroBg}')` }}
      >
        <div className="page-hero-overlay"></div>
        <div className="container">
          <div className="page-hero-content">
            <div className="hero-service-icon">
              <i className={`fa ${product.heroIcon}`}></i>
            </div>
            <h1 className="page-title">{product.title}</h1>
            <nav className="breadcrumb-nav">
              <Link to="/">Home</Link>
              <span className="sep">/</span>
              <Link to="/#products">Products</Link>
              <span className="sep">/</span>
              <span className="current">{product.title}</span>
            </nav>
          </div>
        </div>
      </section>

      {/* ============ SERVICE OVERVIEW SECTION ============ */}
      <section className="service-overview-section pt-60 pb-60">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-lg-8 mb-4 mb-lg-0" data-aos="fade-right" data-aos-delay="100">
              <div className="overview-icon-wrap">
                <i className={`fa ${product.heroIcon}`}></i>
              </div>
              <div className="subtitle subtitle_1bececf" style={{ marginBottom: '12px' }}>
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">Business Automation Platform</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
              <div className="title title_1bececf" style={{ marginBottom: '16px' }}>
                <h2>
                  <span></span>
                  <span>Scalable and Reliable IT Products</span>
                  <span></span>
                </h2>
              </div>
              <p style={{ color: '#555', fontSize: '1.05rem', lineHeight: '1.8' }}>
                {product.overview.desc}
              </p>
              <ul className="overview-checklist">
                {product.overview.checklist.map((item, idx) => (
                  <li key={idx}>
                    <i className="fa fa-check-circle"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="btn-common primary-btn global-btn-style" style={{ display: 'inline-flex' }}>
                <span>Request Demo / Assessment</span>
              </Link>
              <a href="tel:+8801839602840" className="btn-common secondary-btn global-btn-style" style={{ display: 'inline-flex', marginLeft: '12px' }}>
                <span>+880 1839-602840</span>
              </a>
            </div>

            <div className="col-lg-4" data-aos="fade-left" data-aos-delay="200">
              <div className="services-sidebar-widget">
                <div className="ssw-header">
                  <h3>
                    <i className="fa fa-th-list" style={{ marginRight: '8px', color: 'var(--color-primary, #2400A8)' }}></i>
                    All Products
                  </h3>
                </div>
                <ul className="ssw-list">
                  {allProducts.map((p) => (
                    <li key={p.slug}>
                      <Link
                        to={`/products/${p.slug}`}
                        className={p.slug === slug ? 'active' : ''}
                      >
                        <i className={`fa ${p.icon}`}></i>
                        {p.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="contact-widget">
                <i className="fa fa-headset cw-big-icon"></i>
                <h4>Need Help?</h4>
                <p>Talk to our technical leads for a customized product consultation.</p>
                <a href="tel:+8801839602840" className="cw-btn cw-btn-phone">
                  <i className="fa fa-phone"></i>
                  +880 1839-602840
                </a>
                <a href="https://wa.me/8801839602840" target="_blank" rel="noopener noreferrer" className="cw-btn cw-btn-wa">
                  <i className="fab fa-whatsapp"></i>
                  WhatsApp Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ SUB-SERVICES SECTION ============ */}
      <section className="sub-services-section pt-60 pb-60">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-down">
            <div className="subtitle subtitle_1bececf">
              <h4>
                <span className="subtitle-first-span"></span>
                <span className="subtitle-middle-span">{product.subServices.subtitle}</span>
                <span className="subtitle-last-span"></span>
              </h4>
            </div>
            <div className="title title_1bececf">
              <h2>
                <span></span>
                <span>{product.subServices.title}</span>
                <span></span>
              </h2>
            </div>
          </div>
          <div className="row">
            {product.subServices.items.map((capability, idx) => (
              <div key={idx} className="col-lg-3 col-md-6 mb-4" data-aos="flip-left" data-aos-delay="100">
                <div className="ssc">
                  <div className="ssc-icon">
                    <i className={`fa ${capability.icon}`}></i>
                  </div>
                  <h3>{capability.title}</h3>
                  <p>{capability.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ SERVICE CTA SECTION ============ */}
      <section className="service-cta-sec">
        <div className="container" data-aos="fade-up">
          <h2>Ready to Secure Your Premium IT Stack?</h2>
          <p>Contact us today for a free setup consultation and product demonstration.</p>
          <Link to="/contact" className="btn-cta-gold">Request Demo Setup</Link>
          <a href="tel:+8801839602840" className="btn-cta-outline-white">
            <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>
            +880 1839-602840
          </a>
        </div>
      </section>
    </>
  );
}
